import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Search = ({
  tableManager,
  value = tableManager.searchApi.searchText,
  onChange = tableManager.searchApi.setSearchText
}) => {
  const {
    config: {
      texts: {
        search: searchText
      },
      icons: {
        search: searchIcon
      },
      additionalProps: {
        search: additionalProps = {}
      }
    }
  } = tableManager;
  let classNames = ('rgt-search-container ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...additionalProps,
    className: classNames,
    children: [/*#__PURE__*/_jsxs("label", {
      htmlFor: "rgt-search",
      className: "rgt-search-label",
      children: [/*#__PURE__*/_jsx("span", {
        className: "rgt-search-icon",
        children: searchIcon
      }), searchText]
    }), /*#__PURE__*/_jsx("input", {
      name: "rgt-search",
      type: "search",
      value: value,
      onChange: event => onChange(event.target.value),
      className: "rgt-search-input"
    })]
  });
};

export default Search;